
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faQuoteLeft,faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import {} from "@fortawesome/free-regular-svg-icons";
import {} from "@fortawesome/free-brands-svg-icons";
import {Card, Button } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import "./TutorEarning.css";
import $ from "jquery";
import HeaderSub from "../HeaderSub/HeaderSub";

export default () => {
  {
    $(".frequently-qstn .btn-link").click(function () {
      if ($(this).parent().hasClass("show-clr")) {
        $(this).parent().removeClass("show-clr");
      } else {
        $(".frequently-qstn .card-header").removeClass("show-clr");
        $(this).parent().addClass("show-clr");
      }
    });
  }
  return (
    <div className="container">
      <div className="tutor-earning-page float-left w-100">
        {/* header */}
        <HeaderSub/>
        {/* setup-top */}
        <div className="setup-top float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-lg-6 col-12">
                <div className="setup-left float-left w-100">
                  <label>EARNINGS</label>
                  <h2>How you make money on Askademia</h2>
                  <p>
                      Find out your potential earnings per subject each month
                  </p>
                  <div className="earnbox float-left w-100">
                  <form>
                      <div className="row">
                      <div className="col-12">
                          <span className="price-tag">£ 1200 per month <FontAwesomeIcon icon={faInfoCircle} /></span>
                      </div>  
                        <div className="col-lg-4 col-md-4 col-sm-4 pr-lg-0 pr-md-0">
                          <div className="fields float-left w-100">
                            <input
                              type="text"
                              name="subject"
                              placeholder="Lorem"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 pr-lg-0 pr-md-0">
                          <div className="fields float-left w-100">
                            <select>
                              <option>your level</option>
                              <option>your level</option>
                              <option>your level</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4">
                          <button>Get Started</button>
                        </div>
                      </div>
                    </form>
                    </div>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="setup-right float-left w-100">
                  <img src={require("../../assets/images/setup-top.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* how work */}
        <div className="work-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-12">
                <div className="work-head float-left w-100">
                  <h1>Getting paid</h1>
                  <p>
                      Our payment methods to tutors include direct bank transfer or PayPal, either way 
                      tutors are paid no more than 48 hours after session has taken place.
                  </p>
                </div>
              </div>
              <div className="workk float-left w-100" id="one">
                <div className="">
                  <div className="row">
                    <div className="col-lg-5 col-md-6 col-12">
                      <div className="work-left float-left w-100">
                        <div className="work-count float-left w-100">
                          <span>01</span>
                        </div>
                        <div className="after-style first-style">
                          <div className="work-content">
                            <h3>Tutor profile & verification</h3>
                            <p>
                              Lorem ipsum dolor sit amet, qu ve scaevola cum
                              alienum verterem in, sit liber iusto Rem amet,
                              consectetur adipisicing elit, sed do eiusmo dipsum
                              dolor sit amet, consectetur
                            </p>
                          </div>
                          <span className="circle-back">
                            <span className="circle"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="offset-1"></div>
                    <div className="col-lg-5 col-md-5 col-12">
                      <div className="work-img float-left w-100">
                        <FontAwesomeIcon icon={faBookOpen} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="workk float-left w-100" id="two">
                <div className="">
                  <div className="row">
                    <div className="col-lg-5 col-md-5 col-12">
                      <div className="after-style">
                        <div className="work-img float-left w-100">
                          <FontAwesomeIcon icon={faBookOpen} />
                        </div>
                        <span className="circle-back">
                          <span className="circle"></span>
                        </span>
                      </div>
                    </div>
                    <div className="offset-1"></div>
                    <div className="col-lg-5 col-md-6 col-12">
                      <div className="work-left float-left w-100">
                        <div className="work-count float-left w-100">
                          <span>02</span>
                        </div>
                        <div className="work-content">
                          <h3>Tutoring request</h3>
                          <p>
                            Lorem ipsum dolor sit amet, qu ve scaevola cum alienum
                            verterem in, sit liber iusto Rem amet, consectetur
                            adipisicing elit, sed do eiusmo dipsum dolor sit amet,
                            consectetur
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="workk float-left w-100" id="one">
                <div className="">
                  <div className="row">
                    <div className="col-lg-5 col-md-6 col-12">
                      <div className="work-left float-left w-100">
                        <div className="work-count float-left w-100">
                          <span>03</span>
                        </div>
                        <div className="after-style three-style">
                          <div className="work-content">
                            <h3>Get paid after lession</h3>
                            <p>
                              Lorem ipsum dolor sit amet, qu ve scaevola cum
                              alienum verterem in, sit liber iusto Rem amet,
                              consectetur adipisicing elit, sed do eiusmo dipsum
                              dolor sit amet, consectetur
                            </p>
                          </div>
                          <span className="circle-back">
                            <span className="circle"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="offset-1"></div>
                    <div className="col-lg-5 col-md-5 col-12">
                      <div className="work-img float-left w-100">
                        <FontAwesomeIcon icon={faBookOpen} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* mid-section */}
        <div className="mid-section-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="mid-section-left float-left w-100">
                  <FontAwesomeIcon icon={faQuoteLeft} />
                  <h2>Lorem ipsum dolor sit amet percipiturcum sit amet, qu ve scaevola cum</h2>
                  <p>Lorem ipsum dolor sit amet, qu ve scaevola cum alienum</p>
                  <div className="start-btn float-left w-100">
                    <a href="#">Learn how they tutor</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-12">
                <div className="mid-section-right float-left w-100">
                  <img
                    src={require("../../assets/images/mid-section.jpg")}
                    srcSet={`
                      ${require("../../assets/images/mid-sectionm.jpg")} 450w, 
                      ${require("../../assets/images/mid-section.jpg")}
                      `}
                    alt="banner"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* control-tutor */}
        <div className="control-tutor-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-12">
                <div className="control-head float-left w-100">
                  <h1>Setting price</h1>
                  <p>
                    Our payment methods to tutors include direct bank transfer or
                    PayPal, either way tutors are paid no more than 48 hours after
                    session has taken place.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="tutor-plan float-left w-100">
                  <div className="img float-left w-100">
                    <FontAwesomeIcon icon={faBookOpen} />
                  </div>
                  <div className="content float-left w-100">
                    <span>Price advice</span>
                    <p>
                      Lorem ipsum dolor sit amet, qui ex velit scaevola percipi
                      tur, Vim id quot quando. Lorem ipsum dolor sit amet, qui ex
                      liber iusto convenire ad Vim id quot quando.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="tutor-plan float-left w-100">
                  <div className="img float-left w-100">
                    <FontAwesomeIcon icon={faBookOpen} />
                  </div>
                  <div className="content float-left w-100">
                    <span>Custom prices</span>
                    <p>
                      Lorem ipsum dolor sit amet, qui ex velit scaevola percipi
                      tur, Vim id quot quando. Lorem ipsum dolor sit amet, qui ex
                      liber iusto convenire ad Vim id quot quando.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* frequently qstn */}
        <div className="frequently-qstn-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-12">
                <div className="main-head float-left w-100">
                  <h1>Frequently asked questions</h1>
                </div>
              </div>
              <div className="col-12">
                <div className="frequently-qstn float-left w-100">
                  <Accordion defaultActiveKey="0">
                    <Card>
                      <Card.Header className="show-clr">
                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                          Who can be an Askademia tutor?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="1">
                          What is required of tutors before tutoring?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="1">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="2">
                          How much does it cost to register as a tutor?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="2">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="3">
                          What insurance protection do I have as a tutor?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="3">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="4">
                          How should I choose my session prices?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="4">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="5">
                          What subjects I can teach?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="5">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ready-to */}
        <div className="ready-to-m float-left w-100 mb-5">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="ready-to float-left w-100">
                  <h3>Ready to tutoring?</h3>
                  <div className="start-btn float-left w-100">
                    <a href="#">Get Started</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="overlay"></div>
        </div>
      </div>
    </div> 
  );
};
